import * as Types from '../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAdvantageVersusCashQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAdvantageVersusCashQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, totalNetAdvantage: number } };

export type GetBudgetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBudgetsQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, tenant: string, budgets: Array<{ __typename?: 'EmployeeBudget', balance: number, budget: { __typename?: 'Budget', id: string, code: Types.BudgetCode, choiceCycle: { __typename?: 'ChoiceCycle', start?: any | null, end?: any | null, status: Types.BudgetStatus }, name: { __typename?: 'LocalizedText', en: string, fr?: string | null, nl?: string | null }, activationStatus: { __typename?: 'BudgetActivationStatus', active: boolean } } }> } };


export const GetAdvantageVersusCashDocument = gql`
    query GetAdvantageVersusCash {
  employee {
    id
    totalNetAdvantage
  }
}
    `;

/**
 * __useGetAdvantageVersusCashQuery__
 *
 * To run a query within a React component, call `useGetAdvantageVersusCashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvantageVersusCashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvantageVersusCashQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvantageVersusCashQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>(GetAdvantageVersusCashDocument, options);
      }
export function useGetAdvantageVersusCashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>(GetAdvantageVersusCashDocument, options);
        }
export function useGetAdvantageVersusCashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>(GetAdvantageVersusCashDocument, options);
        }
export type GetAdvantageVersusCashQueryHookResult = ReturnType<typeof useGetAdvantageVersusCashQuery>;
export type GetAdvantageVersusCashLazyQueryHookResult = ReturnType<typeof useGetAdvantageVersusCashLazyQuery>;
export type GetAdvantageVersusCashSuspenseQueryHookResult = ReturnType<typeof useGetAdvantageVersusCashSuspenseQuery>;
export type GetAdvantageVersusCashQueryResult = Apollo.QueryResult<GetAdvantageVersusCashQuery, GetAdvantageVersusCashQueryVariables>;
export const GetBudgetsDocument = gql`
    query GetBudgets {
  employee {
    id
    tenant
    budgets {
      balance
      budget {
        id
        code
        choiceCycle {
          start
          end
          status
        }
        name {
          en
          fr
          nl
        }
        activationStatus {
          active
        }
      }
    }
  }
}
    `;

/**
 * __useGetBudgetsQuery__
 *
 * To run a query within a React component, call `useGetBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
      }
export function useGetBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
        }
export function useGetBudgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetsQuery, GetBudgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(GetBudgetsDocument, options);
        }
export type GetBudgetsQueryHookResult = ReturnType<typeof useGetBudgetsQuery>;
export type GetBudgetsLazyQueryHookResult = ReturnType<typeof useGetBudgetsLazyQuery>;
export type GetBudgetsSuspenseQueryHookResult = ReturnType<typeof useGetBudgetsSuspenseQuery>;
export type GetBudgetsQueryResult = Apollo.QueryResult<GetBudgetsQuery, GetBudgetsQueryVariables>;